<template>
  <PageTemplate>
    <div class="element-wrapper">
      <div class="element-box">
        <h6 class="element-header">
          Mitarbeiterprofil
        </h6>


        <div class="element-content">
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12">
              <div class="row mb-4 mt-4">
                <div class="col-lg-5 col-6">
                  <div class="user-profile-label">Mitarbeiternummer:</div>
                  <div class="user-profile-label">Vorname:</div>
                  <div class="user-profile-label">Nachname:</div>
                  <div class="user-profile-label">Straße:</div>
                  <div class="user-profile-label">Eintrittstermin:</div>
                  <div class="user-profile-label">Geburtsdatum:</div>
                  <div class="user-profile-label">Geschlecht:</div>
                  <!--                <div class="user-profile-label">Mitarbeitertyp:</div>-->
                  <div class="user-profile-label">Rechte:</div>
                  <div class="user-profile-label">Anstellungsart:</div>
                  <div class="user-profile-label">Standorte:</div>
                </div>
                <div class="col-lg-7 col-6">
                  <div class="user-profile-data">{{ piniaCurrentUser?.employeeNumber }}</div>
                  <div class="user-profile-data">{{ piniaCurrentUser?.firstName }}</div>
                  <div class="user-profile-data">{{ piniaCurrentUser?.lastName }}</div>
                  <div class="user-profile-data">{{ piniaCurrentUser?.address }}</div>
                  <div class="user-profile-data">{{ piniaCurrentUser?.startingDate }}</div>
                  <div class="user-profile-data">{{ piniaCurrentUser?.birthdate }}</div>
                  <div class="user-profile-data">{{ piniaCurrentUser?.genderTranslation }}</div>
                  <!--                <div class="user-profile-data">{{ piniaCurrentUser?.employeeType }}</div>-->
                  <div class="user-profile-data">{{ piniaCurrentUser?.accessRightTranslated }}</div>
                  <div class="user-profile-data">{{ piniaCurrentUser?.engagementTypeTranslation }}</div>
                  <div class="user-profile-data">
                    <div v-for="(location, index) in  piniaCurrentUser?.locations" :key="index">
                      {{ location.name }}
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-xg-4 col-lg-6 col-md-12 col-sm-12 text-center">
              <div v-if="piniaCurrentUser.digitalSignatureBase64">
                <p>Aktuelle Signatur</p>
                <img class="img-fluid" :src="piniaCurrentUser.digitalSignatureBase64"
                     style="object-fit: contain; border: 1px solid rgb(208, 208, 208);" alt=""/>
              </div>

              <br>
              <button class="btn btn-primary ml-2" @click.stop="handleDigitalSignatureModal()">
                Digitale Unterschrift
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal
        v-model="showDigitalSignatureModal"
        title="Digitale Unterschrift"
        :hide-cancel="true"
        :button-label="$t('general.button.save')"
        sizeModal="modal-md"
        :hide-footer="true"
        classFooter="justify-content-center">
      <DigitalSignatureForm
          :currentUserData="piniaCurrentUser"
          @update-signature="updateSignature"/>
    </Modal>
  </PageTemplate>
</template>

<script setup>
import Modal from '@/components/modal/Modal.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast } from '@/components/VueToast';
import { piniaUserStore } from '@/store/piniaUserStore';
import DigitalSignatureForm from '@/views/App/User/Profile/DigitalSignatureForm.vue';
import { computed, ref } from 'vue';

const piniaUserState            = piniaUserStore();
const piniaCurrentUser          = computed(() => piniaUserState.currentUser.user);
const showDigitalSignatureModal = ref(false);

function updateSignature(newSignature) {
  // Directly update the reactive pinia state
  showDigitalSignatureModal.value               = false;
  piniaCurrentUser.value.digitalSignatureBase64 = newSignature;
}

function handleDigitalSignatureModal() {
  CloseToast();
  showDigitalSignatureModal.value = true;

}

</script>
<style scoped>

</style>